import axios from 'axios';

export default axios.create({
    baseURL: "https://extranet-sinistre.api.azertyconsulting.fr/api/v1",
    headers: {
        "Content-type": "application/json",
        'Access-Control-Allow-Origin': '*',
    }
});